// removed by extract-text-webpack-plugin
module.exports = {"root":"_1HrNsS_","container":"_26n2mwK","saraBanner":"_16LnnBO","saraContent":"_31dB818","saraLogo":"_1a_xKFK","saraDescription":"_2HHJDet","saraButton":"_6YBqch"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/SARABanner/SARABanner.less
 ** module id = 781
 ** module chunks = 0
 **/